import Room from '@/components/Room/Room'

const CreateOrEnterRoom = () => {
  return <Room />
}

export default CreateOrEnterRoom
